import React, { useEffect, useState } from "react";
import { Checkbox } from "flowbite-react";
import { differenceInDays, isBefore, parse, startOfDay } from "date-fns";
import { useContrato } from "../../../../../../../context/ContratoContext";
// import { Total } from "../../../../../../../services/data/dummyContratos";
import { useModal } from "../../../../../../../hooks/ModalContext";
import { TabelaParcelasData } from "../parcelasData";
import { useDividas } from "../../../../../../../context/DividasContext";
import { BiMinusCircle, BiPlusCircle } from "react-icons/bi";
import { Radio } from "../../../../../../generics/radio";
import {
  RequestParamsSimulate,
  useNeg,
} from "../../../../../../../context/NegContext";
import { Contrato } from "../../../../../../../types/contratos-data-interface";
import { ConsultaParametrosData, SimularAcordoData } from "../../../../../../../types/simular-acordo-interface";
import { credoresGazin } from "../../../../../../../utils/credoresGazin";
import { Divida } from "../../../../../../../types/divida-interface";
import { useAuth } from "../../../../../../../context/AuthContext";

interface ContratoDataProps {
  simulacao: ConsultaParametrosData;
  tipoNeg: string;
  app?: string
}

export const ContratoData = ({ simulacao, tipoNeg, app }: ContratoDataProps) => {
  const { contratosData, getDividasWS, dividaData } = useContrato();
  const { selectedCredor, devedor, devedorCadastro } = useDividas();
  const {
    addParcelasNegGroup,
    setSelection,
    stateSelection,
    contratoNeg,
    addContrato,
    getParamsSimulate,
    getValores,
    parcelasNeg,
    setSimulacaoCalculadora
  } = useNeg();
  const { setModal } = useModal();
  const [show, setShow] = useState(false);
  const { cookies } = useAuth()

  const parcelasNovas: Divida[] = dividaData && dividaData?.length > 0 ? dividaData?.filter((item) => {
    const hoje = startOfDay(new Date());
    const dataVencimento = parse(item.datvenci, "dd/MM/yyyy", new Date());
    return isBefore(dataVencimento, hoje);
  }) : [] as Divida[]

  useEffect(() => {
    const isAP =
      tipoNeg === "AP" &&
        credoresGazin.find((item) => selectedCredor?.credor_crm === item)
        ? true
        : false;
    getValores(
      simulacao?.regrassimularacordo?.valormaximodesconto,
      isAP,
      simulacao?.regrassimularacordo?.valoratualdivida
    )

  }, [parcelasNeg, simulacao]);

  useEffect(() => {
    // if (parcelasNeg?.length !== dividaData?.length && parcelasNeg?.length > 0 && stateSelection !== 'selectLate') {
    //   setSelection('NaMao')
    // }
    setSimulacaoCalculadora({} as SimularAcordoData)
    if (parcelasNeg?.length === 0) {
      const element = document.getElementById('resumo') as HTMLDetailsElement;
      if (element) {
        element.open = false
      }
    }

    if (parcelasNeg?.length > parcelasNovas?.length) {
      setSelection('Sem seleção')
    }


  }, [parcelasNeg])

  useEffect(() => {
    setShow(false);
    setSelection("unselect");
  }, [selectedCredor]);

  function selections(state: string) {
    setSelection(state);
    if (state === "selectAll") {
      addParcelasNegGroup(dividaData);
    } else if (state === "selectLate") {
      // const parcelasNovas = dividaData.filter((item) => {
      //   const hoje = startOfDay(new Date());
      //   const dataVencimento = parse(item.datvenci, "dd/MM/yyyy", new Date());
      //   return isBefore(dataVencimento, hoje);
      // });
      addParcelasNegGroup(parcelasNovas);
    } else {
      addParcelasNegGroup([], true);
      const element = document.getElementById('resumo') as HTMLDetailsElement;
      if (element) {
        element.open = false
      }
    }
  }

  async function checkedContrato(
    cpf_cnpj: string,
    codcredor: string,
    contrato: string,
    isCheck?: boolean
  ) {
    if (isCheck && show) {
      setShow(true);
      return;
    }
    if (dividaData?.length <= 0) {
      const d = await getDividasWS({
        codcredor,
        contrato,
        cpf_cnpj,
        url: selectedCredor.url_ws,
        app
      });
      setSelection("selectAll");
      addParcelasNegGroup(d);
      const params: RequestParamsSimulate = {
        tipo: "AV",
        url: selectedCredor.url_ws,
        codcredor: String(selectedCredor.credor_crm),
        cpf_cnpj: devedorCadastro?.cpfcnpj,
        usuario: String(cookies?.user?.id_operador),
        contratos: d.map((p) => {
          return {
            idparcial: p.idparcial,
            numcontrato: p.contrato,
            valpago: p.valorpago,
            filial: p.filial,
            datvenci: p.datvenci,
            numeroparcela: p.numeroparcela,
          };
        }),
        app
      };
      await getParamsSimulate(params);
    }
    setShow(!show);
  }

  async function contratoChecked(c: Contrato) {
    if (!contratoNeg.numcontrato) {
      setSelection("selectAll");
      addParcelasNegGroup(dividaData);
    }
    // else {
    //   setSelection("unselect");
    //   addParcelasNegGroup([], true);
    // }
    addContrato(c, true);
    await checkedContrato(
      devedor.cpf_cnpj || "",
      c.codcredor,
      c.numcontrato,
      true
    );
    if (!contratoNeg.numcontrato && c.permiteacordo)
      setModal("AVISO", "Aviso", false, true);
    if (show) {
      setShow(true);
      return;
    }
  }

  function formatDate(date: string) {
    const [dia, mes, ano] = date.split("/");
    return `${mes}/${dia}/${ano}`;
  }
  return (
    <>
      {contratosData?.contratos?.length > 0 &&
        contratosData.contratos.map((c) => (
          <div key={c.numcontrato} className={`mb-4 rounded-md bg-white `}>
            <div className="flex w-full rounded-md border border-gray-400 pr-2">
              <div
                className={`mr-2 w-2 rounded-l-md ${c.permitedivida ? " bg-green-500" : " bg-red-500"
                  } `}
              ></div>
              <div className="w-full py-2">
                <div className="">
                  <div className="my-2 flex items-center justify-between text-sm">
                    <div className="flex items-center ">
                      <Checkbox
                        color="green"
                        className="mr-2 bg-primary"
                        onChange={() => {
                          contratoChecked(c);
                        }}
                        checked={
                          c.numcontrato === contratoNeg?.numcontrato
                        }
                      />
                      <strong className="text-xs font-medium text-gray-600">
                        Contrato: {c.numcontrato}
                      </strong>
                    </div>
                    {/* checked={} onChange={() => setRenda(!renda)} */}
                    {c.permiteacordo && (
                      <div className="flex h-fit items-center gap-1 rounded-md bg-purple-100  p-1 ">
                        <p className="font-semibold text-purple-800">Acordo</p>
                      </div>
                    )}

                    <p className="text-xs font-medium text-gray-600">
                      Dias em atraso:
                      <strong className="ml-1">
                        {differenceInDays(
                          new Date(),
                          new Date(formatDate(c.vencimento))
                        )}
                      </strong>
                    </p>

                    <button
                      className="text-lg font-bold"
                      onClick={() => {
                        if (contratoNeg?.numcontrato !== c.numcontrato && !show) {
                          addContrato(c)
                        }
                        if (!show) {
                          setShow(true);
                        }
                        checkedContrato(
                          devedor.cpf_cnpj || "",
                          c.codcredor,
                          c.numcontrato
                        );
                        // showParcelasContrato(c.numcontrato);
                      }}
                    >
                      {show ? (
                        <BiMinusCircle size={24} className="fill-primary" />
                      ) : (
                        <BiPlusCircle size={24} className="fill-primary" />
                      )}
                    </button>
                  </div>
                </div>

                <div className={`${!show && dividaData && "hidden"} `}>
                  <>
                    <div>
                      <div className="mb-4  flex gap-4">
                        <Radio
                          name="checkContrato"
                          sizeText="text-xs"
                          label=" Selecionar todos"
                          checked={stateSelection === "selectAll"}
                          onChange={() => selections("selectAll")}
                        />
                        <Radio
                          name="checkContrato"
                          sizeText="text-xs"
                          label="Selecionar vencidos"
                          checked={stateSelection === "selectLate"}
                          onChange={() => selections("selectLate")}
                        />
                        <Radio
                          name="checkContrato"
                          sizeText="text-xs"
                          label="Selecionar desmarcar"
                          checked={stateSelection === "unselect"}
                          onChange={() => selections("unselect")}
                        />
                      </div>
                    </div>

                    {dividaData && dividaData.length > 0 && (
                      <TabelaParcelasData
                        prestacoes={dividaData}
                        tipoNeg={tipoNeg}
                      />
                    )}


                  </>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};
